import { InfluencerDetail } from '../../../models/influencer';
import { CommonConstant, listOrderedPlatforms } from '../../app.constants';
import { InfluencerService } from '../../services/influencer/influencer.service';
import { PdfExportService } from '../../services/export-pdf/pdf-export.service';
import { Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { Kpi } from '../../../models/common';
import { DeviceDetectorService } from 'ngx-device-detector';
import { WebUtils } from '../../utils/web.utils';
var InfluencerBasicInformationComponent = /** @class */ (function () {
    function InfluencerBasicInformationComponent(influencerService, pdfService, userService, deviceService, router) {
        this.influencerService = influencerService;
        this.pdfService = pdfService;
        this.userService = userService;
        this.deviceService = deviceService;
        this.router = router;
        this.allowRedirectToInfluencerPage = false;
        this.enableForMediaPlatform = true;
        this.platformList = [];
        this.tooltipChannels = [];
        this.platformList = listOrderedPlatforms.map(function (p) { return p.id; });
    }
    Object.defineProperty(InfluencerBasicInformationComponent.prototype, "isInInfluencerApp", {
        get: function () {
            return this.userService.isInfluencer;
        },
        enumerable: true,
        configurable: true
    });
    InfluencerBasicInformationComponent.prototype.hasPlatform = function (id) {
        if (!this.influencer) {
            return false;
        }
        var hasPlatform = false;
        if (Array.isArray(this.influencer.platforms)) {
            hasPlatform = this.influencer.platforms.filter(function (pl) { return pl.id === id; }).length > 0;
        }
        var hasChannel = false;
        if (Array.isArray(this.influencer.channels)) {
            hasChannel = this.influencer.channels.filter(function (channel) { return channel.platform.id === id; }).length > 0;
        }
        return hasPlatform || hasChannel;
    };
    InfluencerBasicInformationComponent.prototype.getHandle = function (id) {
        if (!this.influencer || !this.influencer.channels) {
            return null;
        }
        var platformHandles = this.influencer.channels.filter(function (channel) { return channel.platform.id === id; }).map(function (c) { return c.handle; });
        return platformHandles.join('\n');
    };
    Object.defineProperty(InfluencerBasicInformationComponent.prototype, "countryName", {
        get: function () {
            if (!this.influencer || !this.influencer.country) {
                return null;
            }
            return this.influencer.country.name;
        },
        enumerable: true,
        configurable: true
    });
    InfluencerBasicInformationComponent.prototype.getPlatformIcon = function (id) {
        return this.influencerService.getPlatformIconById(id);
    };
    InfluencerBasicInformationComponent.prototype.getCountryCode = function (influencer) {
        return influencer && influencer.country && influencer.country.code ?
            influencer.country.code.toLowerCase() : CommonConstant.INTERNATION_COUNTRY_CODE;
    };
    InfluencerBasicInformationComponent.prototype.onLoadedAvatarUser = function () {
        this.pdfService.updateNumberImageLoaded(InfluencerBasicInformationComponent.COMPONENT_NAME);
    };
    InfluencerBasicInformationComponent.prototype.openInfluencerDetails = function () {
        if (!this.allowRedirectToInfluencerPage) {
            return;
        }
        if (!this.enableForMediaPlatform) {
            return this.router.navigate(['dashboard', 'details']);
        }
        return this.router.navigate(['influencer', this.influencer.id, 'overview'], {
            queryParams: {
                activeAccount: this.userService.getCompanyId(),
            }
        });
    };
    Object.defineProperty(InfluencerBasicInformationComponent.prototype, "numberOfPost", {
        get: function () {
            return this.postCount ? this.postCount : this.influencer ? this.influencer.numberOfPosts : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerBasicInformationComponent.prototype, "numberOfFollower", {
        get: function () {
            return this.followerCount ? this.followerCount : this.influencer ? this.influencer.numberOfFollowers : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerBasicInformationComponent.prototype, "globalKpi", {
        get: function () {
            return this.customKpi ? this.customKpi : this.influencer ? this.influencer.globalKpi : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerBasicInformationComponent.prototype, "onMobile", {
        get: function () {
            return this.deviceService.isMobile();
        },
        enumerable: true,
        configurable: true
    });
    InfluencerBasicInformationComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.pdfService.imagedLoadedTrigger.subscribe(function (data) {
            if (data.component === InfluencerBasicInformationComponent.COMPONENT_NAME && data.currentCounter === 1) {
                _this.pdfService.incrementNumberReportReady(InfluencerBasicInformationComponent.COMPONENT_NAME);
            }
        });
    };
    InfluencerBasicInformationComponent.prototype.toggleChannelIndicator = function (tooltip, platformId) {
        // Do nothing if no tooltip
        if (!tooltip) {
            return;
        }
        // close the current tooltip if click new tooltip
        if (this._clickedTooltip && this._clickedTooltip !== tooltip) {
            this._clickedTooltip.close();
        }
        // if user click on the open tooltip
        // keep it open if it is hovered
        // otherwise, close it
        if (tooltip.isOpen() && tooltip !== this._hoverTooltip) {
            tooltip.close();
            this._clickedTooltip = null;
            return;
        }
        if (this.openChannelIndicatorTooltip(tooltip, platformId)) {
            this._clickedTooltip = tooltip;
        }
    };
    InfluencerBasicInformationComponent.prototype.openChannelIndicatorTooltip = function (tooltip, platformId) {
        if (!this.influencer || !this.influencer.channels) {
            return false;
        }
        this.tooltipChannels = this.influencer.channels
            .filter(function (channel) { return channel.platform.id === platformId; })
            .map(function (c) {
            return {
                handle: c.handle,
                status: c.status,
                link: WebUtils.buildSocialChannelLink({
                    name: c.platformName,
                    domain: c.platform.domain
                }, c.handle)
            };
        });
        tooltip.open();
        return true;
    };
    InfluencerBasicInformationComponent.prototype.onClickOutsideTooltip = function (target) {
        // Find the element to check where user click inside another tooltip
        // Inside => ignore because behavior will be handle in click handler
        // Not inside => close clicked popup
        var channelIndicatorContainerElement = target.closest('[data-type=channel-indicator]');
        if (channelIndicatorContainerElement) {
            return;
        }
        if (!this._clickedTooltip) {
            return;
        }
        this._clickedTooltip.close();
        this._clickedTooltip = null;
    };
    InfluencerBasicInformationComponent.prototype.onTooltipMouseEnter = function (tooltip, platformId) {
        if (!tooltip || this._clickedTooltip) {
            return;
        }
        if (this.openChannelIndicatorTooltip(tooltip, platformId)) {
            this._hoverTooltip = tooltip;
        }
    };
    InfluencerBasicInformationComponent.prototype.onTooltipMouseOut = function (tooltip) {
        if (!tooltip || this._clickedTooltip) {
            return;
        }
        if (tooltip.isOpen()) {
            this._hoverTooltip = null;
            tooltip.close();
        }
    };
    InfluencerBasicInformationComponent.COMPONENT_NAME = 'InfluencerBasicInformationComponent';
    return InfluencerBasicInformationComponent;
}());
export { InfluencerBasicInformationComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer-basic-information/influencer-basic-information.component.ts.pre-build-optimizer.js